import { scaleTime } from 'd3-scale';
import { useMemo, useEffect } from 'react';

const LABEL_WIDTH = 74;

const useCalculateSliderPillMargin = (
  sliderRef: HTMLElement | null,
  playerWidth: number,
  bucketStartTimeInMs: number,
  bucketEndTimeInMs: number,
  sliderTimeValue?: number | null,
) => {
  const adjustedPlayerWidth = useMemo(() => playerWidth * 0.9, [playerWidth]);

  const xScale = useMemo(
    () =>
      scaleTime().domain([bucketStartTimeInMs, bucketEndTimeInMs]).range([0, adjustedPlayerWidth]),
    [bucketStartTimeInMs, bucketEndTimeInMs, adjustedPlayerWidth],
  );

  useEffect(() => {
    let labelStyles = `min-width: ${LABEL_WIDTH}px;`;
    const halfLabelWidth = LABEL_WIDTH / 2;
    const playerDiff = playerWidth - adjustedPlayerWidth;
    const halfPlayerDiff = playerDiff / 2;
    const scrubberCircleWidth = 12;
    const halfScrubberCircleWidth = scrubberCircleWidth / 2;
    const clientXPosition = xScale(sliderTimeValue || 0);

    const leftMarginCalc = halfPlayerDiff + Math.ceil(clientXPosition);
    const shouldAddLeftMargin = leftMarginCalc < halfLabelWidth + halfScrubberCircleWidth;
    if (shouldAddLeftMargin) {
      const leftMargin = halfLabelWidth - clientXPosition;
      labelStyles = `${labelStyles} margin-left: ${leftMargin}px;`;
    }

    const rightMarginCalc = adjustedPlayerWidth - clientXPosition;
    const shouldAddRightMargin = rightMarginCalc < halfPlayerDiff;
    if (shouldAddRightMargin) {
      const rightMargin = halfLabelWidth - rightMarginCalc;
      labelStyles = `${labelStyles} margin-right: ${rightMargin}px;`;
    }

    if (sliderRef) {
      sliderRef.querySelector('.MuiSlider-valueLabelLabel')?.setAttribute('style', labelStyles);
    }
  }, [adjustedPlayerWidth, playerWidth, sliderRef, sliderTimeValue, xScale]);
};

export default useCalculateSliderPillMargin;
